import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent, IconComponent } from 'nebula-ui-kit';

export interface PageHeaderAction {
  id: string;
  label: string;
  icon?: string;
  variant?: 'primary' | 'secondary' | 'danger';
  disabled?: boolean;
  visible?: boolean;
  loading?: boolean;
  /** Solo icono (p. ej. UserCheck en Bóveda Digital, paridad tarjetas del explorador). */
  iconOnly?: boolean;
}

/** Compatible con título + icono con color opcional (mismo patrón que nebula-erp). */
export interface PageHeaderIconConfig {
  name: string;
  color?: string;
}

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, IconComponent, ButtonComponent],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  title = input.required<string>();
  subtitle = input<string>('');
  /** Nombre de icono del kit, o config con color opcional. */
  icon = input<string | PageHeaderIconConfig | undefined>(undefined);
  actions = input<PageHeaderAction[]>([]);
  actionClick = output<string>();

  protected iconName(): string | null {
    const v = this.icon();
    if (v == null) return null;
    if (typeof v === 'string') return v;
    return v.name;
  }

  protected iconColor(): string | undefined {
    const v = this.icon();
    if (v != null && typeof v === 'object') return v.color;
    return undefined;
  }
}
